import React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'antd/dist/antd.css';
import 'react-virtualized-select/styles.css'
import 'react-select/dist/react-select.css'
import "./resources/semantic/theme/semantic-ui.css";
import "./styles/bootstrap.scss";
import "./styles/app.scss";
import "./App.scss";
import "./Vendor";
import  Herramientas  from '../src/LogisticsTools';
// import { Shipment } from './components/Shipments/ShipmentsDetail';
// import { Search } from './components/Search';
// import { ShowResults } from './components/Results';
// import { ListResult } from './components/ListResults'


// import { GlobalProvider } from './context/GlobalState';

function App() {
  return (
    // <GlobalProvider>
      <Switch>
        <Route path="/" component={Herramientas} exact />
        {/* <Route path="/search" component={Search} exact />
        <Route path="/results" component={ShowResults} exact />
        <Route path="/track" component={Shipment} exact />
        <Route path="/tracking/:id" component={ListResult} exact /> */}
      </Switch>
    // </GlobalProvider>
  );
}

export default App;
